export default {
      id: "girl-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#girl",
      toString: function () {
        return this.url;
      }
    }